<template>
  <swiper :options="swiperOption">
    <swiper-slide v-for="(banner, idx) in bannerList" :key="idx">
      <template v-if="isImage(banner.extension)">
        <a @click="requestBannerUrl(banner.connectUrl)">
          <img class="banner-image" :src="banner.filePath" alt="" />
        </a>
      </template>

      <template v-else-if="isVideo(banner.extension)">
        <div class="play-video">
          <video :ref="'myVideo' + idx" class="myVideo" controls height="260px">
            <source
              v-if="banner.extension === '.mp4'"
              :src="banner.filePath"
              type="video/mp4"
            />
            <source
              v-if="banner.extension === '.ogg'"
              :src="banner.filePath"
              type="video/ogg"
            />
          </video>
        </div>
      </template>
    </swiper-slide>
    <swiper-slide v-if="bottomBannerUrl">
      <youtube
        :video-id="findVideoId(bottomBannerUrl)"
        :player-vars="playerVars"
        ref="youtube"
        class="youtube-player"
      />
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script src="https://www.youtube.com/iframe_api"></script>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapGetters } from "vuex";

export default {
  name: "ObituaryBannerList",
  props: ["skinBanner"],
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1, // 한 번에 하나의 슬라이드만 보여줌
        spaceBetween: 6,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,

        centerInsufficientSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      playerVars: {
        modestbranding: 1,
        // playlist: videoId,
        width: "100%",
        loop: 1
      }
    };
  },

  computed: {
    bannerList() {
      return this.skinBanner?.bannerList;
    },
    bottomBannerUrl() {
      return this.skinBanner?.bottomBannerUrl;
    }
  },
  methods: {
    isImage(extension) {
      return (
        extension.startsWith("image/") ||
        [".jpg", ".png", ".jpeg"].includes(extension)
      );
    },
    isVideo(extension) {
      return (
        extension.startsWith("video/") || [".mp4", ".ogg"].includes(extension)
      );
    },

    requestBannerUrl(url) {
      if (!url) {
        return;
      }

      if (url.indexOf("https://") !== -1 || url.indexOf("http://") !== -1) {
        window.open(url);
      } else if (url.indexOf("tel:") === 0) {
        window.open(url);
      } else {
        window.open(`http://${url}`);
      }
    },

    findVideoId(url) {
      return url
        .substr(url.indexOf("watch?v="), url.length)
        .replace("watch?v=", "");
    }
  }
};
</script>
<style lang="scss" scoped>
.swiper-container {
  .swiper-wrapper {
    .swiper-slide img {
      width: 100%;
    }
  }
}
</style>
<style>
.swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.757);
}
.swiper-pagination .swiper-pagination-bullet-active {
  opacity: 1;
  background: rgb(26, 131, 235);
}

.swiper-pagination {
  /* background-color: rgba(255, 255, 255, 0.609); */
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content !important;
  height: 56px;
  padding: 0 4px;
  border-radius: 50px;
  bottom: 10px !important;
  right: 0;
  margin: auto;
}

.banner-image {
  width: 100%;
  height: 280px;
  object-fit: contain;
}

.play-video {
  width: 100%;
  height: 280px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  display: block;
}

.youtube-player {
  width: 100%;
  max-width: 420px;
  height: 200px;
}
</style>
